import { Component, Input, Output, EventEmitter } from '@angular/core';
import { AlergyTypeService } from '../services/alergy.type.service';
import { AlergyType } from '../models/alergy.type.model';
import { NotificationService } from '../services/notification.service';

@Component({
  selector: 'app-alergy-type-form',
  templateUrl: './alergy-type-form.component.html'
})
export class AlergyTypeFormComponent {
  constructor(public service: AlergyTypeService, private notificationService: NotificationService) { }

  @Input() model: AlergyType;
  @Output() closeModal: EventEmitter<any> = new EventEmitter();

  submitted = false;

  ngOnInit() {
    //this.notificationService.showDatePicker();
  }

  onSubmit() {
    this.submitted = true;
    this.service.model = this.model;
    if (!this.model.alergyTypeID)
      this.insertRecord();
    else
      this.updateRecord();
  }


  insertRecord() {

    this.service.post().subscribe(
      res => {
        this.notificationService.notifySuccess();

        this.closeModal.emit(null);
      },
      err => { console.log(err); }
    )
  }

  updateRecord() {

    this.service.put().subscribe(
      res => {
        this.notificationService.notifySuccess();

        this.closeModal.emit(null);
      },
      err => {
        console.log(err);
      }
    )
  }


}

